"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommunicationPreferenceBasis = exports.CommunicationPreferenceSource = exports.COMMUNICATION_PREFERENCE_QUESTION_TITLE_MAX_LENGTH = exports.CommunicationPreferenceFormType = void 0;
// Values match the global FormType where they overlap, but newsletter forms are outside it.
var CommunicationPreferenceFormType;
(function (CommunicationPreferenceFormType) {
    CommunicationPreferenceFormType["DonationForm"] = "DonationForm";
    CommunicationPreferenceFormType["Ticketing"] = "Ticketing";
    CommunicationPreferenceFormType["NewsletterForm"] = "NewsletterForm";
})(CommunicationPreferenceFormType || (exports.CommunicationPreferenceFormType = CommunicationPreferenceFormType = {}));
exports.COMMUNICATION_PREFERENCE_QUESTION_TITLE_MAX_LENGTH = 255;
var CommunicationPreferenceSource;
(function (CommunicationPreferenceSource) {
    CommunicationPreferenceSource["FormSubmission"] = "formSubmission";
    CommunicationPreferenceSource["ManualEntry"] = "manualEntry";
    CommunicationPreferenceSource["Import"] = "import";
    CommunicationPreferenceSource["Migration"] = "migration";
    CommunicationPreferenceSource["PreferencePage"] = "preferencePage";
})(CommunicationPreferenceSource || (exports.CommunicationPreferenceSource = CommunicationPreferenceSource = {}));
// Whether a question was put to the contact about this list, and where the consent rests when none was.
var CommunicationPreferenceBasis;
(function (CommunicationPreferenceBasis) {
    // An affirmative act covering this list: a ticked box, or a sign-up form submitted with no box to tick.
    CommunicationPreferenceBasis["Explicit"] = "explicit";
    CommunicationPreferenceBasis["Passive"] = "passive";
    CommunicationPreferenceBasis["Derived"] = "derived";
    // No box shown, and the act it rests on was not about receiving communications.
    CommunicationPreferenceBasis["Implied"] = "implied";
})(CommunicationPreferenceBasis || (exports.CommunicationPreferenceBasis = CommunicationPreferenceBasis = {}));
